import { focusStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: focusStyles(),
    },
};
